import mousetrap from 'mousetrap'
import Vue from 'vue'
import Store from './store'
import Router from './router'

function notify (message = '', type = 'is-dark') {
  Vue.prototype.$toast.open({
    message,
    type
  })
}

mousetrap.bind(['alt+a', 'ctrl+a'], async function () {
  notify('Synchroniseren met AccountView')

  await Store.dispatch('getCrediteuren')
  await Store.dispatch('getDebiteuren')

  notify('Synchroniseren voltooid')
})

/*****************************
    MENU
 *****************************/

mousetrap.bind('b', async function () {
  Router.push({ name: 'receipts.concept' })
})

mousetrap.bind('f', async function () {
  Router.push({ name: 'invoices.purchase' })
})

mousetrap.bind('c', async function () {
  Router.push({ name: 'crediteuren' })
})

mousetrap.bind('d', async function () {
  Router.push({ name: 'debiteuren' })
})



// WEBPACK FOOTER //
// ./src/shotcodes.js